import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';

import { ensureActiveOrg, getActiveUserId } from '@shared/utils';

export const githubRedirectGuard: CanActivateFn = (route: ActivatedRouteSnapshot): UrlTree | boolean => {
  const router = inject(Router);
  const queryParams = route.queryParams;

  const activeUserId = getActiveUserId();
  const orgId = ensureActiveOrg(activeUserId);
  if (!orgId) {
    return router.createUrlTree(['/account-dashboard'], { queryParams });
  }

  return router.createUrlTree(['/org', orgId, 'github'], {
    queryParams
  });
};
